const CDN_RESOURCES_PREFIX = 'https://cdn-static.bizzabo.com/bizzabo.resources/';

// Default placeholders seeded into section data point straight at the bucket;
// security scanners flag raw object-storage references, so serve them via the CDN.
const LEGACY_S3_RESOURCE_PREFIXES = [
    'https://s3.amazonaws.com/bizzabo.resources/',
    'http://s3.amazonaws.com/bizzabo.resources/',
    'https://bizzabo.resources.s3.amazonaws.com/',
    'http://bizzabo.resources.s3.amazonaws.com/'
];

const rewriteString = value => {
    const lowerCased = value.toLowerCase();
    const prefix = LEGACY_S3_RESOURCE_PREFIXES.find(candidate => lowerCased.startsWith(candidate));
    return prefix ? CDN_RESOURCES_PREFIX + value.slice(prefix.length) : value;
};

const isPlainObject = value => {
    if (value === null || typeof value !== 'object') {
        return false;
    }
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};

export default function rewriteLegacyS3ResourceUrls(value) {
    if (typeof value === 'string') {
        return rewriteString(value);
    }
    if (Array.isArray(value)) {
        const mapped = value.map(rewriteLegacyS3ResourceUrls);
        return mapped.some((item, index) => item !== value[index]) ? mapped : value;
    }
    if (!isPlainObject(value)) {
        return value;
    }
    let changed = false;
    const result = {};
    Object.keys(value).forEach(key => {
        result[key] = rewriteLegacyS3ResourceUrls(value[key]);
        changed = changed || result[key] !== value[key];
    });
    return changed ? result : value;
}
